import type { ReactNode } from "react";

import { Prose } from "../core/Prose.js";
import { Text } from "../core/Text.js";
import { Section } from "./Section.js";

export interface DocumentPageProps {
  /** The page's one h1: "Terms of Service". */
  title: string;
  /** A line under the title: when the text last changed. */
  meta?: ReactNode;
  /** The document, as plain semantic HTML (sections, h2, p, lists, links); Prose sets its type. */
  children: ReactNode;
}

/**
 * A long document on its own page (terms, a privacy policy): its title, a line saying when it
 * last changed, and the text in a reading column, in the page's width and gutters.
 */
export function DocumentPage({ title, meta, children }: DocumentPageProps) {
  return (
    <Section className="pt-8 pb-20 md:pt-12">
      <article className="mx-auto flex max-w-3xl flex-col">
        <Text as="h1" variant="display-xl3" tone="primary" className="max-md:text-display-xl4">
          {title}
        </Text>
        {meta && (
          <Text as="p" variant="body-b2" tone="tertiary" className="mt-2">
            {meta}
          </Text>
        )}
        <Prose className="mt-6">{children}</Prose>
      </article>
    </Section>
  );
}
